import { createFileRoute } from "@tanstack/react-router";
import { UserProfile } from "@/settings/profile/UserProfile";

export const Route = createFileRoute("/(authed)/_layout/settings/profile")({
  component: UserProfile,
  loader: () => ({ crumb: "Profile" }),
});
